import './styles.css';
import React from 'react';

function Badge(
  { className, line0, line3, line4, disableSubline, languageSettings }
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 400 200"
      width="100%"
      height="100%"
      className={`BlankBadge_2 Badge ${className}`}
    >

      {/* ------------------------------------------ */}

      <g className="RECTANGLE">
        <rect
          width="400"
          height="200"
          opacity="0"
          className="_Badge__FirstFillColor"
        />
      </g>

      {/* ------------------------------------------ */}

      <g className="TEXT">

        <text
          x="50%"
          y="26%"
          dy=".9ex"
          textAnchor="middle"
          fontFamily="Anton"
          fontSize={languageSettings.small ? '5em' : '10em'}
          letterSpacing="0em"
          className="Badge__FirstFillColor"
        >
          {line0.toUpperCase()}
        </text>

        {!disableSubline
          ? <text
              x="50%"
              y={languageSettings.small ? '70%' : '90%'}
              textAnchor="middle"
              fontFamily="Rajdhani"
              fontSize={languageSettings.small ? '1.2em' : '1.5em'}
              fontWeight="700"
              letterSpacing="0.1em"
              className="Badge__FirstFillColor"
            >
              {line3.toUpperCase()} {line4.toUpperCase()}
            </text>
          : null}
      </g>

      {/* ------------------------------------------ */}

    </svg>
  );
}

export default Badge;



// WEBPACK FOOTER //
// ./src/shared/badges/blank_2/Badge.jsx